import { render, staticRenderFns } from "./DebugTableLayout.vue?vue&type=template&id=db2dfe92&scoped=true&"
import script from "./DebugTableLayout.vue?vue&type=script&lang=ts&"
export * from "./DebugTableLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DebugTableLayout.vue?vue&type=style&index=0&id=db2dfe92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2dfe92",
  null
  
)

export default component.exports